<template>
  <div v-if="!this.$route.meta.noHeaderFooter">
    <header id="masthead" class="site-header" role="banner" :class="{ on_top: headerHide }" @mouseover="on_top" @mouseleave="remove_on_top">
      <div class="container">
        <div id="brand" class="site-title" rel="home">
          <a href="#" @click.prevent="apply" />
        </div>
        <div class="login-menu visible-xs">
          <ul v-if="loggedIn" class="nav-else">
            <li><button @click="onLogout">로그아웃</button></li>
          </ul>
          <ul v-else class="nav-else">
            <li><router-link to="/login">로그인</router-link></li>
          </ul>
        </div>
        <nav class="site-navigation" role="navigation">
          <ul v-if="loggedIn" class="nav display-block">
            <template v-if="windowWidth > 767">
              <li><a @click.prevent="onLogout">로그아웃</a></li>
              <!-- <li><a href="#" @click.prevent="rentalHistory">이용내역</a></li> -->
              <!-- <li><button class="btn" @click.prevent="apply">신청하기</button></li> -->
            </template>
            <template v-else>
              <!-- <li><a href="#" @click.prevent="rentalHistory">이용내역</a></li> -->
              <!-- <li><a href="#" @click.prevent="apply">신청하기</a></li> -->
            </template>
          </ul>
          <ul v-else class="nav display-block">
            <template v-if="windowWidth > 767">
              <li><router-link to="/login">로그인</router-link></li>
              <!-- <li><a href="#" @click.prevent="loginRentalHistory">이용내역</a></li> -->
              <!-- <li><button class="btn" @click.prevent="apply">신청하기</button></li> -->
            </template>
            <template v-else>
              <!-- <li><a href="#" @click.prevent="loginRentalHistory">이용내역</a></li> -->
              <!-- <li><a href="#" @click.prevent="apply">신청하기</a></li> -->
            </template>
          </ul>
          <!-- <ul id="gnb" class="nav">
            <li
              v-for="(menu, index) in menus"
              :key="menu.id"
              :class="{ has_submenu: menu.hasSubmenu, open: menu.open }"
            >
              <template v-if="windowWidth > 767">
                <router-link
                  :to="menu.link"
                  :class="{ 'router-link-exact-active': isParentMenu(index)}"
                  v-text="menu.name"
                />
              </template>
              <template v-else>
                <a
                  v-if="menu.hasSubmenu"
                  :class="{ 'font-brand': isParentMenu(index)}"
                  @click="toggleMenu(index)"
                  v-text="menu.name"
                />
                <router-link v-else :to="menu.link" v-text="menu.name" />
              </template>
              <ul
                v-if="menu.hasSubmenu"
                class="nav-submenu"
                :class="{ show: menu.open }"
              >
                <li v-for="submenu in menu.submenus" :key="submenu.name">
                  <router-link :to="submenu.link" v-text="submenu.name" />
                </li>
              </ul>
            </li>
          </ul> -->
        </nav>
      </div>
    </header>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { throttle } from 'lodash';
import ApiClient, { API } from 'api/client';
import config from 'config';
import HeaderUtil from 'utils/header';
import { postMessageToPlanHome } from 'utils/webview/postMessageToPlanHome';
import { closeWebView } from 'utils/webview/closeWebView';
import { isWebview } from 'utils/webview/isWebview';

export default {
  name: 'SiteHeader',
  mixins: [ApiClient],
  props: [
  ],
  data() {
    return {
      menu_active: false,
      headerHide: false,
      navToggle: false,
      windowWidth: 0,
      user_name: '',
      // menus: [
      //   {
      //     id: 'application',
      //     name: '신청하기',
      //     hasSubmenu: false,
      //     open: false,
      //     link: '/',
      //   },
      // ],
      currentViewport: (this.$route.meta.pcViewPort ? 'width=1200' : 'width=device-width, initial-scale=1, maximum-scale=1,user-scalable=0'),
      userAgent: '',
    };
  },
  computed: {
    loggedIn() {
      return !!this.$store.state.user.logged;
    },
  },
  watch: {
    $route: ['getHeaderType', 'getAsyncData'],
  },
  created() {
    this.checkWindowWidth();
    this.getHeaderType();
  },
  mounted() {
    window.addEventListener('resize', throttle(this.checkWindowWidth, 500));
  },
  methods: {
    ...mapActions('user', ['logout']),
    ...mapActions(['updateAccessToken']),
    on_top() {
      document.getElementById('masthead').classList.remove('on_top');
    },
    apply() {
      if (isWebview()) {
        postMessageToPlanHome('/');
        closeWebView();
        return;
      }
      window.location.href = config.planHome.baseURL;
    },
    rentalHistory() {
      if (isWebview()) {
        postMessageToPlanHome('/mypage');
        closeWebView();
        return;
      }
      window.location.href = config.rentalHistory.baseURL;
    },
    loginRentalHistory() {
      this.$router.push('/login?redirect=rental-history');
    },
    remove_on_top() {
      const scrollTop = window.pageYOffset;
      if (scrollTop > 0) {
        document.getElementById('masthead').classList.remove('on_top');
      } else {
        document.getElementById('masthead').classList.add('on_top');
      }
    },
    toggleMenu(index) {
      this.menus[index].open = !this.menus[index].open;
      this.menus.forEach((current, i) => {
        if (index !== i) {
          const menu = current;
          menu.open = false;
        }
      });
    },
    getAsyncData() {
      const self = this;
      self.currentViewport = (self.$route.meta.pcViewPort ? 'width=1200' : 'width=device-width,initial-scale=1.0');
      self.$emit('updateHead');
      this.navToggle = false;
    },
    checkWindowWidth() {
      this.windowWidth = document.documentElement.clientWidth;
    },
    async onLogout() {
      this.logout();
      this.updateAccessToken('');
      const cookieName = HeaderUtil.isWebView() ? 'auth_token' : 'plan_auth_token';
      const SsoLoginApi = this.getApi(API.SSOLOGIN);
      await SsoLoginApi.deleteCookie({ cookieName });
      window.gtag('set', 'user_properties', {
        user_id: '',
        env: (window.location.host.indexOf('localhost') > -1 || window.location.host.indexOf('socar.me') > -1) ? 'development' : 'production',
      });
      this.$router.push('/login');
    },
    navController() {
      if (this.navToggle === false) {
        document.body.classList.add('nav_open');
        this.navToggle = true;
      } else {
        document.body.classList.remove('nav_open');
        this.navToggle = false;
      }
    },
    getHeaderType() {
      this.headerHide = this.$route.meta.headerHide;
    },
    isParentMenu(menuIndex) {
      const indexSubmenus = this.menus[menuIndex].submenus;
      const menuArray = [];
      if (indexSubmenus) {
        const that = this;
        indexSubmenus.find((el) => {
          if (el.link === that.$route.path) {
            menuArray.push(el.link);
            return true;
          }
          return false;
        });
      }
      if (menuArray.length) {
        return true;
      }
      return false;
    },
    closeNav() {
      document.body.classList.remove('nav_open');
      this.navToggle = false;
    },
  },
  head: {
    meta() {
      return [
        { name: 'viewport', content: this.currentViewport },
      ];
    },
  },
  destroy() {
    window.removeEventListener('resize', this.checkWindowWidth);
  },
};
</script>

<style>
.display-block {
  display: block !important;
}
</style>
